import OnlinePaymentContactAddressResourceModel from '../../generated/types/model/resource/OnlinePaymentContactAddressResourceModel';

export default class OnlinePaymentContactAddressResourceViewModel extends OnlinePaymentContactAddressResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
